function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useEffect, useState } from "react";
import { calculateGenderAffinityFromCounts, calculateTopAffinityFromCounts } from "../affinities/top-affinities";
import { universalAtob } from "../utils/base64-conversions";
import log from "../logger";
import { PEPS_PROFILE_STORAGE_NAME, CURRENT_AFFINITY_KEY, AFFINITY_GENDER } from "../consts";
export var profileFromString = function(profile) {
    try {
        // Plugin stringifies the profile
        var parameters = JSON.parse(profile);
        if (typeof parameters === "string") {
            // Storage util also stringifies
            parameters = JSON.parse(parameters);
        }
        var entries = Object.entries(parameters);
        // Profile obfuscates stored values
        return entries.reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            try {
                var decodedKey = JSON.parse(universalAtob(key));
                var decodedValue = JSON.parse(universalAtob(value));
                acc[decodedKey] = decodedValue;
            } catch (err) {
                // Log the error if decoding fails
                log.error(err, {
                    tags: {
                        componentName: "useProfile",
                        functionName: "profileFromString"
                    }
                });
                // Skip this key-value pair if decoding fails
                acc[key] = value;
            }
            return acc;
        }, {});
    } catch (err) {
        // Log the outer error if the entire process fails
        log.error(err, {
            tags: {
                componentName: "useProfile",
                functionName: "profileFromString"
            }
        });
        return {};
    }
};
export var addCurrentToAffinities = function(parameters) {
    return Object.entries(parameters).reduce(function(sum, param) {
        var _param = _sliced_to_array(param, 2), name = _param[0], items = _param[1];
        // eslint-disable-next-line no-param-reassign
        if (typeof items !== "object") {
            return _extends({}, sum, _define_property({}, name, items));
        }
        if (CURRENT_AFFINITY_KEY in items) {
            // if previous current exists delete it so it doesn't get considered in calculations
            // eslint-disable-next-line no-param-reassign
            delete items.current;
        }
        var current = name === AFFINITY_GENDER ? calculateGenderAffinityFromCounts(items) : calculateTopAffinityFromCounts(items);
        return _extends({}, sum, _define_property({}, name, _extends({
            // used by call from db as well, items will overwrite this timestamp line
            timestamp: new Date().toISOString()
        }, items, {
            current: current
        })));
    }, {});
};
export var enrichProfile = function(data) {
    var _data;
    var profile = {};
    if (!((_data = data) == null ? void 0 : _data.length)) return profile;
    //each time we want to add something to the affinities profile add here
    profile = profileFromString(data);
    profile = addCurrentToAffinities(profile);
    return profile;
};
var useProfile = function() {
    var _useState = _sliced_to_array(useState({}), 2), profile = _useState[0], setProfile = _useState[1];
    //listen to localstorage changes and update the profile
    useEffect(function() {
        var storageValue = window.localStorage.getItem(PEPS_PROFILE_STORAGE_NAME);
        setProfile(enrichProfile(storageValue));
        var handleStorageChange = function(e) {
            var _e;
            if (e.key === PEPS_PROFILE_STORAGE_NAME && ((_e = e) == null ? void 0 : _e.newValue)) {
                setProfile(enrichProfile(e.newValue));
            }
        };
        window.addEventListener("storage", handleStorageChange);
        return function() {
            return window.removeEventListener("storage", handleStorageChange);
        };
    }, []);
    return profile;
};
export default useProfile;
